import React from 'react';

export const CustomCardPayout=(props)=>{
    return(
        <div className={`col mt-3 ${props.paddingTop ?props.paddingTop:null }`} data-cy="payout-card">
            <div className={`stockbox wow fadeInUp staticHeightPayout ${props.color} whiteoverlaycir text-white`} data-wow-delay="0.3s" data-wow-duration="0.7s">
                <h2 className="text-center text-dark mt-sm-3">{props.value}</h2>
                <div className="textdiv text-center text-dark fw-bold">{props.label}</div>
            </div>
        </div>
    )
}